import firebase from "firebase/compat/app";
import "firebase/compat/database";

const firebaseConfig = {
  apiKey: "AIzaSyDF9Qh0kYRwJ8gvNX8POKCgUe44_Cldoko",
  authDomain: "abrahamsf-16ad5.firebaseapp.com",
  databaseURL: "https://abrahamsf-16ad5-default-rtdb.firebaseio.com",
  projectId: "abrahamsf-16ad5",
  storageBucket: "abrahamsf-16ad5.appspot.com",
  messagingSenderId: "382472143986",
  appId: "1:382472143986:web:6915cb14db784233e56eeb",
};

const adminConfig = firebase.initializeApp(firebaseConfig, "adminApp");

export default adminConfig.database();
